<template>
    <div class="actions">
        <div class="box">
            <div class="actions-func">
                <Select class="margin-r10 shadow112006" v-model="selectedws_id" style="width:150px" @on-change="changeTag">
                    <Option :value="0">{{$t('all')}}</Option>
                    <Option v-for="item in allShops" :value="item.ws_id" :key="item.ws_id">{{ item.name }}</Option>
                </Select>
                <Input class="margin-r10 shadow112006" v-model="machineName" :placeholder="$t('groupName')" style="width:150px;"/>
                <Button type="info" class="margin-r10 shadow112006" icon="md-search" @click="searchMachine">{{$t('search')}}</Button>
                <Button type="primary" class="margin-r10 shadow112006" icon="md-add" @click="isShowAdd = true" v-if="$store.state.user.rank==1">{{$t('addGroup')}}</Button>
                <Button type="info" class="shadow112006" icon="md-apps" v-if="toChangeDisMode==0" @click="changeDisplayMode">{{$t('a_cardShow')}}</Button>
                <Button class="shadow112006" icon="md-list" v-else @click="changeDisplayMode">{{$t('a_listShow')}}</Button>
            </div>
            <div class="group-data shadow112006">
                <div class="item">
                    <em class="tx">
                        <Icon type="md-pie"/>
                        {{$t('useRate')}}
                    </em>
                    <strong class="val">
                        {{run}}
                        <b>%</b>
                    </strong>
                </div>
                <div class="item">
                    <em class="tx">
                        <Icon type="md-flash"/>
                        {{$t('powerNum')}}
                    </em>
                    <strong class="val">
                        {{kwh}}
                        <b>kwh</b>
                    </strong>
                </div>
                <div class="item">
                    <em class="tx">
                        <Icon type="md-podium"/>
                        {{$t('finishNum')}}
                    </em>
                    <strong class="val">{{allData.finish}}/{{allData.total}}</strong>
                </div>
                <div class="item">
                    <em class="tx">
                        <Icon type="md-pulse"/>
                        {{$t('finishRate')}}
                    </em>
                    <strong class="val">
                        {{finish}}
                        <b>%</b>
                    </strong>
                </div>
            </div>
        </div>
        <Modal v-model="isShowAdd" @on-ok="doAdd" @on-cancel="cancel" width="400" @on-visible-change="addModalVisibleChange">
            <p slot="header">
                <Icon type="md-add"/>
                <span>{{$t('addGroup')}}</span>
            </p>
            <Form :model="group" :label-width="80">
                <FormItem :label="$t('groupName')">
                    <Input v-model="group.name" :placeholder="$t('groupName')"/>
                </FormItem>
                <FormItem :label="$t('tagName')">
                    <Select v-model="group.ws_id">
                        <Option :value="0">{{$t('a_noShop')}}</Option>
                        <Option v-for="item in allShops" :key="item.ws_id" :value="item.ws_id">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('b_groupSort')">
                    <InputNumber v-model="group.sort" :placeholder="$t('b_groupSort')" :precision="0" style="width:100%"/>
                </FormItem>
                <FormItem :label="$t('b_selectDevice')" style="margin-bottom:0;">
                    <Select v-model="group.dev_idsArr" multiple>
                        <Option v-for="item in noUsedDevices" :key="`kind${item.dev_id}`" :value="item.dev_id">{{item.name}}</Option>
                    </Select>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>
<script>
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';

export default {
    props: {
        allData: Object, //所有数据的综合
        displayMode: Number //0卡片 1列表
    },
    data() {
        return {
            allShops: [],
            selectedws_id: '', //选择的车间的id
            machineName: '', //要查询的机组名称
            isShowAdd: false, // 是否显示添加机组对话框
            toChangeDisMode: this.displayMode == 0 ? 1 : 0, //将要去列表显示或卡片显示
            noUsedDevices: [], //未使用（无机组）的设备
            group: {
                name: '',
                ws_id: 0,
                sort: 0,
                dev_idsArr: '',
                dev_ids: [],
                cid: this.$store.state.user.cid
            }
        };
    },
    mounted() {
        // 有效工厂
        this.allShops = [];
        Axios.get(AxiosUrl.workshop.select, {
            params: {
                cid: this.$store.state.user.cid
            }
        }).then(res => {
            if (res.data.code == 200) {
                this.allShops = res.data.data;
                this.selectedws_id = this.$store.state.homeSelectShop;
            } else {
                console.log(res.data.msg);
            }
        });
    },
    computed: {
        run() {
            let total = this.allData.run + this.allData.stby + this.allData.alarm + this.allData.stop + this.allData.off;
            if (total > 0) {
                return ((this.allData.run / total) * 100).toFixed(1);
            }
            return '0.0';
        },
        finish() {
            if (this.allData.total > 0) {
                return ((this.allData.finish / this.allData.total) * 100).toFixed(1);
            }
            return '0.0';
        },
        kwh() {
            if (this.allData.power > 0) {
                return (this.allData.power / 10).toFixed(1);
            }
            return '0.0';
        }
    },
    methods: {
        // 添加机组的modal状态改变
        addModalVisibleChange(show) {
            if (show) {
                Axios.get(AxiosUrl.device.select, {
                    params: {
                        cid: this.$store.state.user.cid,
                        gid: 0
                    }
                }).then(res => {
                    if (res.data.code == 200) {
                        this.noUsedDevices = res.data.data;
                    } else {
                        console.log(res.data.msg);
                    }
                });
            }
        },
        // 确认添加设备
        doAdd() {
            if (this.group.name == '' || this.group.kind == '') {
                this.$Message.error(this.$t('a_hasEmpty'));
                return;
            }
            if (this.group.dev_idsArr.length != 0) {
                this.group.dev_ids = this.group.dev_idsArr.join('-');
            }
            Axios.get(AxiosUrl.group.add, {
                params: this.group
            })
                .then(response => {
                    if (response.data.code == 200) {
                        this.$Message.success(this.$t('addSuccess'));
                        this.$emit('refresh');
                        this.group.name = '';
                        this.group.dev_idsArr = [];
                        this.group.dev_ids = '';
                        this.group.ws_id = 0;
                        this.group.sort = 0;
                    } else {
                        this.$Message.error(response.data.msg);
                    }
                })
                .catch(error => {});
        },
        cancel() {
            this.group.name = '';
            this.group.ws_id = 0;
        },
        changeTag(ws_id) {
            this.machineName = '';
            this.$emit('on-selectedws_id-change', ws_id, this.machineName);
        },
        //查询机器
        searchMachine() {
            this.$emit('on-search-machine', this.machineName);
        },
        //修改显示方式
        changeDisplayMode() {
            this.$store.commit('displayMode', this.toChangeDisMode);
            this.$emit('on-change-display', this.toChangeDisMode);
            this.toChangeDisMode = this.toChangeDisMode == 0 ? 1 : 0;
        }
    }
};
</script>
<style lang="less">
.box {
    .group-data {
        display: flex;
        align-items: center;
        border-radius: 3px;
        font-size: 20px;
        .item {
            padding: 0 20px;
            display: flex;
            align-items: baseline;
            .tx {
                font-size: 16px;
                font-style: normal;
            }
            .val {
                color: #108985;
                font-size: 22px;
                display: flex;
                align-items: baseline;
                margin-left: 5px;
                b {
                    font-weight: normal;
                    font-size: 12px;
                    padding: 0;
                }
            }
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/views/home/components/actions.vue